import { useEffect, useState } from 'react';
import {
  Alert,
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Input,
  Modal,
  Row,
} from 'reactstrap';
import { useHistory } from 'react-router-dom';
import UserSmallHeader from 'components/Headers/UserSmallHeader';
import api from 'services/api';
import { FaInfoCircle, FaUndo } from 'react-icons/fa';
import toast from 'react-hot-toast';
import Swal from 'sweetalert2';
import LocalObra from './LocalObra';

export default function PropostaAjuste(): JSX.Element {
  const [proposta, setProposta] = useState<any>({});
  const [propostaValidaManutencao, setPropostaValidaManutencao] =
    useState<boolean>(false);
  const [propostaManutencao, setPropostaManutencao] = useState<string>('');
  const [propostaVersaoManutencao, setPropostaVersaoManutencao] =
    useState<string>('');
  const [formModalState, setFormModalState] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const STATUS_ID_APROVADO = 3;

  async function buscarProposta() {
    const response = await api.get(
      `/proposta/${propostaManutencao}`,
      // `/proposta/${propostaManutencao}/${propostaVersaoManutencao}`,
    );

    return response.data;
  }

  async function handleValidarProposta() {
    try {
      if (propostaManutencao) {
        const registro = await buscarProposta();
        setProposta(registro);
        setPropostaValidaManutencao(true);
        setFormModalState(false);
      }
    } catch (e) {
      console.log(e);
    }
  }

  function openModalProposta(clearAll: boolean) {
    if (clearAll) {
      setPropostaManutencao('');
      setPropostaVersaoManutencao('');
      setProposta({});
      setPropostaValidaManutencao(false);
    }
    setFormModalState(true);
  }

  function closeModal() {
    setFormModalState(false);
  }

  return (
    <>
      <UserSmallHeader />
      <Modal
        className="modal-dialog-centered"
        size="md"
        isOpen={formModalState}
        toggle={closeModal}
      >
        <div className="modal-body p-0">
          <Card className="bg-secondary shadow border-0">
            <CardHeader>
              <h1 className="text-center">Proposta para Ajuste</h1>
              <small>Informe a proposta para ajuste:</small>
              <br />
            </CardHeader>
            <CardBody>
              {propostaValidaManutencao && (
                <Alert color="warning">
                  <FaInfoCircle /> Alterações realizadas serão perdidas ao
                  clicar em <strong>Iniciar Edição</strong>
                </Alert>
              )}
              <Row>
                <Col sm="6" className="mx-auto">
                  <div className="text-center">
                    <Input
                      placeholder="Proposta"
                      type="text"
                      value={propostaManutencao}
                      onChange={text =>
                        setPropostaManutencao(text.target.value)
                      }
                      className="form-control-sm"
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col sm="12">
                  <div className="text-center">
                    <Button
                      className="my-4"
                      color="default"
                      type="button"
                      disabled={isLoading}
                      onClick={closeModal}
                    >
                      Fechar
                    </Button>

                    <Button
                      className="my-4"
                      color="primary"
                      type="button"
                      disabled={isLoading}
                      onClick={handleValidarProposta}
                    >
                      Iniciar Edição
                    </Button>
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </div>
      </Modal>

      <Card>
        <CardHeader>
          <Row>
            <Col sm="6">
              <h5 className="h3 mb-0">Propostas - Ajuste</h5>
              <small>Alteração de informações de proposta </small>
            </Col>
            <Col sm="6">
              <div className="float-right">
                <Button
                  className="my-4"
                  color="primary"
                  size="sm"
                  type="button"
                  title="Selecionar Proposta"
                  onClick={() => openModalProposta(false)}
                >
                  <FaUndo /> Selecionar Proposta
                </Button>
              </div>
            </Col>
          </Row>
        </CardHeader>

        <CardBody className="p-0 pr-1 pl-1" style={{ background: '#ebf3fa' }}>
          {/* {!propostaValidaManutencao && (
            <>
              <div className="ml-2">
                Para abrir a modal e informar o registro que deseja dar
                manutenção{' '}
                <Button
                  className="my-4"
                  color="primary"
                  size="sm"
                  type="button"
                  onClick={() => openModalProposta(true)}
                >
                  Clique aqui
                </Button>
              </div>
            </>
          )} */}
          {propostaValidaManutencao && (
            <>
              <CardHeader className="mt-2">
                <Row>
                  <Col md="4" sm="4" xs="12" lg="4">
                    <h4 className="mb-0">Proposta {proposta.id}</h4>{' '}
                    {/* <small className="mb-0">
                      Versão {proposta.versao} | Configurações{' '}
                      {proposta.PropostaConfiguracao?.map(
                        (config: any) => config.orcamentoId,
                      ).join(', ')}
                    </small> */}
                  </Col>
                  <Col md="3" sm="3" xs="12" lg="4">
                    <small className="mb-0">
                      <strong>Gnf: </strong>
                      {proposta.codigoOportunidadeDomsge ?? ''}
                      <br />
                      <span hidden={!proposta.proposta?.pessoaGnf}>
                        {`${proposta.proposta?.pessoaGnf?.codigoDomsge} - ${proposta.proposta?.pessoaGnf?.razaoSocial}`}
                      </span>
                      <br />
                      <small
                        hidden={
                          (proposta.proposta?.pessoaGnf?.id ?? 0) ===
                          (proposta.proposta?.pessoa?.id ?? 0)
                        }
                      >
                        {`${proposta.proposta?.pessoa?.codigoDomsge} - ${proposta.proposta?.pessoa?.razaoSocial}`}
                      </small>
                    </small>
                  </Col>
                  <LocalObra
                    proposta={proposta}
                    propostaVersaoId={proposta.id}
                  />
                  <Col md="3" sm="3" xs="12" lg="2">
                    <div className="d-flex mt-2">
                      {proposta.status?.descricao ?? ''}
                    </div>
                  </Col>
                </Row>
              </CardHeader>
            </>
          )}
        </CardBody>
      </Card>
    </>
  );
}
